import { FC } from 'react';
import { Link } from '@blueprint/link';
import {
    Content,
    StyledButton,
    StyledText,
    StyledLinkContainer,
    StyledImg,
    StyledHeading,
    StyledIcon,
    Text
} from './ResponseModalContent.styles';

export type Props = {
    image: string;
    title: string;
    heading: string;
    text: string;
    buttonAction: () => void;
    buttonText: string;
    linkType: 'url' | 'action';
    linkUrl?: string;
    linkAction?: () => void;
    linkText: string;
    note: string;
};

export const ResponseModalContent: FC<React.PropsWithChildren<Props>> = ({
    image,
    title,
    heading,
    text,
    buttonAction,
    buttonText,
    linkType,
    linkUrl,
    linkText,
    linkAction,
    note
}) => (
    <Content>
        <StyledImg src={image} alt={title} />
        <StyledHeading size="5">{heading}</StyledHeading>
        <StyledText>{text}</StyledText>
        <StyledButton onClick={buttonAction} color="primary-brand">
            {buttonText}
        </StyledButton>
        <StyledLinkContainer>
            {linkType === 'url' ? (
                <Link href={linkUrl as string}>{linkText}</Link>
            ) : (
                <Link onClick={linkAction} href="">
                    {linkText}
                </Link>
            )}
        </StyledLinkContainer>
        <Text>
            <StyledIcon iconId="padlock" />
            {note}
        </Text>
    </Content>
);
